<script>
import Layout from '@layouts/main';
import ContactForm from '@views/contacts/form';

export default {
  components: {
    Layout,
    ContactForm,
  },
  page() {
    return {
      title: this.$t('titles.create_contact'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.contacts'),
          to: { name: 'contacts.index' },
        },
        {
          text: this.$t('titles.create_contact'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'contacts.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_contact')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <ContactForm @submitted="create" />
    </b-card>
  </Layout>
</template>
